module.exports = __webpack_public_path__ + "img/xr.256184d8.png";